export enum PeReportSubject {
  Employee,
  Supervisor
}
